import { NomineeDetails } from './NomineeDetails'

export default NomineeDetails
